require("intersection-observer");
require("core-js/features/set");
require("core-js/features/array");

require("_fil/fil-global-frontend/countdown");
require("_fil/fil-global-frontend/header");
require("_fil/fil-global-frontend/script");
require("_fil/fil-global-frontend/lazy-load");
require("_fil/fil-global-frontend/video");
require("_fil/fil-global-frontend/login");
require("_fil/fil-global-frontend/polyfill");
require("_fil/fil-global-frontend/cookie-policy-popup");
// require('_fil/global-cms-article/main')
require("_fil/global-cms-article/main");
require("_fil/global-cms-article-base/index");
// require('_fil/global-cms-carousel/carousel')
require("_fil/global-cms-carousel/carousel");
// require('_fil/global-cms-footer/footer')
require("_fil/global-cms-footer/footer");
require("_fil/global-cms-table/table-scroll");
// require('_fil/global-cms-way-finding-bar/global-nav')
require("_fil/global-cms-way-finding-bar/global-nav");
// require('_fil/global-cms-search/search_core')

/* Include your scripts here for local installed addons */
require("_fil_local/camc-fund-data-list/index");
require("_fil_local/camc-cms-card/main");
// require('_fil_local/camc-fund-performance/export-data')
// require('_fil_local/camc-fund-performance/exporting')
// require('_fil_local/camc-fund-performance/highstock')
require("_fil_local/camc-fund-performance/fund-performance");
require("_fil_local/camc-fund-portfolio/website-camc-fund-asset-portfiolio");
require("_fil_local/camc-fund-portfolio/website-camc-fund-industry-distribution");
require("_fil_local/camc-fund-portfolio/website-camc-fund-ten-holding");
require("_fil_local/camc-fund-portfolio/website-camc-fund-five-debt");
require("_fil_local/camc-fund-portfolio/website-camc-fund-fof");
require("_fil_local/camc-fund-fees/website-camc-fund-fees");
require("_fil_local/camc-fund-report-list/index");
require("_fil_local/camc-fund-distributor-table/website-camc-fund-distributor-table");
require("_fil_local/camc-cms-tabs/camc_tabs");
require("_fil_local/camc-investment-capabilities/TweenMax.min");
require("_fil_local/camc-investment-capabilities/function");
require("_fil_local/camc-investment-process/investment-process");
require("_fil_local/camc-fund-overview/website-camc-fund-overview");
require("_fil_local/camc-fund-managers/website-camc-fund-managers");
require("_fil_local/camc-cms-hero/website-camc-hero");
require("_fil_local/camc-cms-messaging/camc-messaging");
require("_fil_local/camc-article-filter/filter");
require("_fil_local/camc-cms-latest-article/main");
require("_fil_local/camc-legal-list/camc-legal-list");
require("_fil_local/camc-cms-text-media-block/camc-text-media-block-carousel");
require("_fil_local/camc-cms-text-media-block/camc-text-media-video-tracking");
require("_fil_local/camc-cms-video/camc-video");
require("_fil_local/camc-cms-video/camc-cms-video-tracking");
require("_fil_local/camc-cms-video/camc-cms-single-youku-video");

require("_fil_local/camc-cms-search/search_core");
require("_fil_local/camc-cms-cookie-policy-popup/cookie-policy-popup");
require("_fil_local/camc-cms-modal/modal");
require("_fil_local/camc-fund-dividend/website-fund-dividend");
require("_fil_local/camc-fund-detail-app/camc-fund-detail-app");
require("_fil_local/camc-fund-detail-app/camc_fund_item_display_control");
require("_fil_local/camc-cms-showhide/main");
require("_fil_local/camc-cms-retirement/main");

/* Include monkeypatch scripts here */
require("_fil_local/fil-camc-monkeypatch/fil_global_frontend/login");

/* Add required site specific javascript files below */
import "./gds3-components";
